import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Flatpickr from 'react-flatpickr'
import '@fil-global/gds-webcomponents/fil-icon/fil-icon.component'
import localeCollection from 'flatpickr/dist/l10n'

import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'

import './style.scss'

const DatePicker = ({
  id,
  invalid,
  labels,
  defaultValues,
  values,
  minMaxDates,
  dateFormatLabel,
  invalidMessage,
  layout,
  mode,
  locale,
  extraClasses,
  handleChangeFuncs
}) => {
  const inputCls = {
    'fil-text-input': true,
    'fil-text-input--calendar': true,
    'fil-text-field--2-cols': layout === '2-cols',
    'fil-text-input--invalid': invalid
  }
  const containerCls = {
    'fil-date-picker-container': true,
    'fil-text-field': true,
    'fil-text-field--invalid': invalid
  }

  const defaultOptions = {
    // allowInput: true,
    prevArrow: `<svg xmlns="http://www.w3.org/2000/svg" data-size="16" viewBox="0 0 24 24" class="fil-icon" fill="none" stroke="currentcolor"><polyline points="17 23 6 12 17 1"/></svg>`,
    nextArrow: `<svg xmlns="http://www.w3.org/2000/svg" data-size="16" viewBox="0 0 24 24" class="fil-icon" fill="none" stroke="currentcolor"><polyline points="7 1 18 12 7 23"/></svg>`,
    locale: localeCollection[locale],
    disableMobile: true
  }

  const getValueIfArray = (targetValue, index) => {
    return Array.isArray(targetValue) ? targetValue[index] : targetValue
  }

  // eslint-disable-next-line react/prop-types
  const DatePickerTemplate = ({ label, defaultValue, value, onChange, minMaxDate, templateClasses }) => {
    const [flatpickerInstance, setFlatpickerInstance] = useState()
    return (
      <Cell extraClasses={classnames('medium-shrink', templateClasses)}>
        <Grid extraClasses={classnames('align-middle', containerCls)}>
          <Cell extraClasses="shrink fil-text-field__description">
            <label {...(id ? { id: `${id}__picker_label` } : {})} className="fil-text-field__label">
              {label}
            </label>
            <p {...(id ? { id: `${id}__picker_text` } : {})} className="fil-text-field__assistive-text">
              {dateFormatLabel}
            </p>
            {invalid && <p className="fil-text-field__error-text">{invalidMessage}</p>}
          </Cell>
          <Cell extraClasses="auto fil-text-field__item flatpickr input-group">
            <Flatpickr
              className={classnames(extraClasses, inputCls)}
              options={{ ...defaultOptions, ...minMaxDate }}
              defaultValue={defaultValue}
              value={value}
              onChange={(e) => {
                onChange(e)
              }}
              ref={(fp) => {
                setFlatpickerInstance(fp)
              }}
            />
            <span
              className="fil-text-field__icon fil-text-field__icon--calendar input-button"
              onClick={() => {
                if (flatpickerInstance) {
                  flatpickerInstance.flatpickr.open()
                }
              }}
            >
              <fil-icon icon="calendar" size="16" />
            </span>
          </Cell>
        </Grid>
      </Cell>
    )
  }

  return (
    <Grid {...(id ? { id } : {})} extraClasses="custom-date-picker">
      <DatePickerTemplate
        label={getValueIfArray(labels, 0)}
        defaultValue={getValueIfArray(defaultValues, 0)}
        value={getValueIfArray(values, 0)}
        minMaxDate={getValueIfArray(minMaxDates, 0)}
        onChange={getValueIfArray(handleChangeFuncs, 0)}
      />
      {mode === 'range' && (
        <DatePickerTemplate
          templateClasses="second"
          label={getValueIfArray(labels, 1)}
          defaultValue={getValueIfArray(defaultValues, 1)}
          value={getValueIfArray(values, 1)}
          minMaxDate={getValueIfArray(minMaxDates, 1)}
          onChange={getValueIfArray(handleChangeFuncs, 1)}
        />
      )}
    </Grid>
  )
}

DatePicker.propTypes = {
  values: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  defaultValues: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  minMaxDates: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      })
    ),
    PropTypes.object
  ]),
  handleChangeFuncs: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]),
  invalid: PropTypes.bool,
  labels: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  dateFormatLabel: PropTypes.string,
  invalidMessage: PropTypes.string,
  extraClasses: PropTypes.string,
  layout: PropTypes.string,
  mode: PropTypes.string,
  locale: PropTypes.string,
  id: PropTypes.string
}

DatePicker.defaultProps = {
  invalid: false,
  defaultValues: [],
  minMaxDates: {},
  handleChangeFuncs: () => {},
  labels: ['Start Label', 'End Label'],
  dateFormatLabel: 'YYYY-MM-DD',
  invalidMessage: 'This is not a valid date',
  extraClasses: '',
  layout: '2-cols',
  mode: 'single',
  locale: 'en',
  id: ''
}

export default DatePicker
